<template>
    <div style="margin-bottom: 100px;">
        <transition name="modal-fade">
            <div class="back" v-if="modal">
                <div class="modal" v-if="modal">
                    <img src="@/assets/cross.svg" id="cross" alt="" @click="modal = false">
                    <header class="modal-header">
                        <div class="header">New project!</div>
                    </header>
                    <section class="modal-body">
                        <p>Start creating a project first. Within a project you can add multiple heatmaps. <br> For example, if you want to keep track of all revisions.</p>
                        <div class="form">
                            <bg-input
                            v-model="project.title"
                            placeholder="Project title"
                            height="46px"
                            />
                            <bg-select id="select" placeholder="Type of input" :options="options"></bg-select>
                            <bg-select id="select" placeholder="Application" :options="options"></bg-select>
                            <bg-select id="select" placeholder="Industry" :options="options"></bg-select>
                        </div>
                    </section>
                    <footer class="modal-footer">
                        <bg-button text="Create project"></bg-button>
                    </footer>
                </div>
            </div>
        </transition>
        <h1 v-bg-typography="'h1'" :style="{'marginTop': '10px'}">Projects <span style="font-size: 12pt; color: #FF00A9">beta</span></h1>
        <p>Heatmaps created: <b>{{ created }}</b> - Credits left: <b>{{ credits }}</b></p>
        
        <div class="top">
            <bg-field
            class="search-input"
            label="Search"
            v-model="searchString"
            name="search"
            >
            <bg-input
                name="search"
                placeholder="Search for project"
                v-model="searchString"
            />
            </bg-field>
            <bg-button text="New project" @click="modal = true"></bg-button>
        </div>


        <div class="cards">
            <HeatmapProjectCard 
            :project="study"
            @analyze="selectProject(study.id)"
            />
        </div>


    </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import BgButton from '@/components/bg-button'
import BgField from '@/components/bg-field'
import BgInput from '@/components/bg-input'
import Project from '@/components/project-card'
import BgSelect from '@/components/bg-select'
import HeatmapProjectCard from '@/components/heatmap-project-card'

export default {
    components: {
        BgButton, BgField, BgInput, Project, BgSelect, HeatmapProjectCard
    },
    directives: {
        BgTypography
    },
    data() {
        return {
            credits: 999,
            created: 12,
            selected: null,
            modal: false,
            project: {
                title: '',
                application: '',
                industry: '',
            },
            options: ['Image','Video'],
            study: {
                createdBy: 'Max van Kaathoven',
                title: 'Landingpage designs',
                added: '01-02-2021',
                type: 'image',
                application: 'UX design',
                versions: 12,
                createdBy: 'Max van Kaathoven',
                id: 1,
                heatmaps: [
                    {
                        title: 'version 4',
                        image: '',
                        clarity: 8.3,
                        readability: 3.5,
                        added: '01-02-2021',
                        addedBy: 'Max van Kaathoven',
                        id: 4
                    },
                    {
                        title: 'version 3',
                        image: '',
                        clarity: 8.3,
                        readability: 3.5,
                        added: '01-02-2021',
                        addedBy: 'Max van Kaathoven',
                        id: 3
                    },
                    {
                        title: 'version 2',
                        image: '',
                        clarity: 8.3,
                        readability: 3.5,
                        added: '01-02-2021',
                        addedBy: 'Max van Kaathoven',
                        id: 2
                    },
                    {
                        title: 'version 1',
                        image: '',
                        clarity: 8.3,
                        readability: 3.5,
                        added: '01-02-2021',
                        addedBy: 'Max van Kaathoven',
                        id: 1
                    }
                ]
            },
            searchString: '',
        }
    },
    computed: {
    },
    methods: {
        selectProject(id) {
            this.$router.push(`/predictions/projects/${id}`)
        }
    }
}
</script>

<style scoped lang="scss">
@import "./styles.scss";

h1 {
    margin-bottom: 10px;
}
.cards {
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
}

.top {
    display: flex;
    gap: 20px;
    margin-top: 30px;
    align-items: flex-end;
    margin-bottom: 20px;
}
.search-input {
    max-width: 250px;
    margin-bottom: 0px;
}

.form {
    max-width: 250px;
    text-align: start;
    margin: auto;
    margin-top: 45px;

    .bg-input {
        border: 1px solid #0B0B3D;
        border-radius: 6px;
    }

    .BgSelect {
        border: 1px solid #0B0B3D;
        border-radius: 6px;
        min-width: 200px;
        margin-top: 20px;
    }
}

</style>